import { render, staticRenderFns } from "./UpdateDeliverymanImage.vue?vue&type=template&id=81a6029c&"
import script from "./UpdateDeliverymanImage.vue?vue&type=script&lang=js&"
export * from "./UpdateDeliverymanImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports